import React from 'react';
import { cn, extractYouTubeID } from "@/lib/utils";

interface MediaYoutubeComponentProps extends React.HTMLAttributes<HTMLElement> {
  url: string;
}

const MediaYoutube = ({ url, className, ...props }: MediaYoutubeComponentProps) => {
  const videoId = extractYouTubeID(url);

  return (
    <div
      className={cn("youtube_player aspect-video", className)}
      data-videoid={videoId}
      data-width="100%"
      data-height="315"
      data-theme="light"
      data-rel="0"
      data-controls="1"
      data-showinfo="0"
      data-autoplay="0"
      data-mute="0"
      data-loop="0"
      data-loading="1"
      {...props}
    />
  );
};

export default MediaYoutube;